// extracted by mini-css-extract-plugin
module.exports = {"header":"About_header__d7el_","aboutContainer":"About_aboutContainer__1Moba","text":"About_text__1AOvt","icons":"About_icons__1YXuh"};